import CheckboxClinicianSelector from './checkbox-selector'

export default CheckboxClinicianSelector
